import { URLService } from '../url.service';
import { DealerShareBuilder } from './dealer.share';
const SharePvareaId = {
  1: { pvareaId: 6844449, getTitle: (dealerName, firstPrize) => `${dealerName}4S店限时红包雨活动开始啦！快来赢取${firstPrize}大奖吧~` },
  2: { pvareaId: 6844450, getTitle: (dealerName, firstPrize) => `${dealerName}4S店限时拼图活动开始啦！快来赢取${firstPrize}大奖吧~` },
  3: { pvareaId: 6844451, getTitle: (dealerName, firstPrize) => `${dealerName}4S店大转盘抽奖活动开始啦！快来赢取${firstPrize}大奖吧~` },
  4: { pvareaId: 6844452, getTitle: (dealerName, firstPrize) => `${dealerName}4S店限时抢红包雨活动开始啦！快来赢取${firstPrize}大奖吧~` },
  5: { pvareaId: 6844453, getTitle: (dealerName, firstPrize) => `${dealerName}4S店限时抢车模活动开始啦！快来赢取${firstPrize}大奖吧~` }
};
export class ActivityShareDataBuilder extends DealerShareBuilder {
  constructor ({ dealerInfo, shareInfo, shareLink, activityInfo, }) {
    super({ dealerInfo, shareInfo });
    this.dealerInfo = dealerInfo;
    this.shareLink = shareLink;
    this.activityInfo = activityInfo;
  }
  buildShareData () {
    const { activityId, activityType, firstPrizeName } = this.activityInfo;
    const dealerName = this.dealerInfo.dealerName;
    let activity = SharePvareaId[activityType];
    let pvareaId = '';
    let title = '汽车之家-智能展厅';
    if (activity) {
      pvareaId = activity.pvareaId;
      title = activity.getTitle(dealerName, firstPrizeName);
    }
    let shareUrl = this.buildActShareUrl(activityType, activityId, pvareaId);
    return { isNative: true, platform: 'all', hideMiniProgram: true, shareUrl, title, desc: '全新技术打造，360无死角浏览，给你不一样的视觉体验' };
  }
  buildActShareUrl (activityType, activityId, pvareaId) {
    let urlService = new URLService(this.shareLink);
    urlService.queryParams
      .remove('pvareaid')
      .remove('activityType')
      .remove('activityId')
      .append('pvareaid', pvareaId)
      .append('activityType', activityType)
      .append('activityId', activityId);
    let shareUrl = urlService.build();
    return shareUrl;
  }
};